module.exports = __webpack_public_path__ + "static/media/pic_3_4_1_en.a19617b1.png";